import React from 'react';
import Modal from '../../commonComponents/util/Modal';
import { Link } from 'react-router-dom';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import ValidatedInput from '../../commonComponents/util/ValidatedInput';
import AutoSuggestInput from '../../commonComponents/util/AutoSuggestInput';
import FadeOutErrorMessage from '../../commonComponents/util/FadeOutErrorMessage';
import LoadingSpinner from '../../commonComponents/util/LoadingSpinner';
import CreateCampaignRecipientModal from '../campaignsCommon/CreateCampaignRecipientModal';
import WarningModal from '../../commonComponents/shared/WarningModal';
import CampaignRecipientApplication from './CampaignRecipientApplication';
import ApplicationStatusTag from '../../commonComponents/shared/ApplicationStatusTag';
import { CurrencyTypes, CampaignListTypes, RecipientTypes } from '../../../lib/systemVariables';
import { PayeeTypes } from '../../../lib/constants';
import { formatCurrency, formatDate } from '../../../lib/utils';
import { getRequest } from '../../../lib/apiUtils';

const initialState = {
  recipient: {},
  newRecipient: {},
  application: {},
  recipientHistory: [],

  wizzardStep: 1,
  loadingRecipientDetails: false,
  dataErrors: [],
  submitAttempted: false,
  checkCampaignRules: true,
  error: false,
  showModals: {
    createRecipientModal: false,
    campaign60DayRuleAlertModal: false,
    campaignAddToActiveRuleAlertModal: false
  }
};

export default class AddCampaignRecipientModal extends NavigationComponent {
  constructor(props) {
    super(props);

    this.state = initialState;
  }

  applicationIsIncomplete = application => {
    if (!application.paymentInfo.fundId) return true;

    const thirdParty = application.paymentInfo.thirdParty;
    if (this.state.dataErrors.length
      || (application.paymentInfo.payTo === PayeeTypes.ThirdParty
        && (!thirdParty.referenceId
          && (
            (!thirdParty.orgName && (!thirdParty.firstName || !thirdParty.lastName))
            || (thirdParty.isIsraeli
              ? (!thirdParty.bankNumber || !thirdParty.branchNumber || !thirdParty.accountNumber)
              : (!thirdParty.address.streetNumber || !thirdParty.address.street || !thirdParty.address.city || !thirdParty.address.country))
          )
        ))
    ) return true;
  }

  async onSubmit(addToActiveCampaign) {
    this.setState({ error: false, submitAttempted: true });

    const { recipient, newRecipient, application } = this.state;

    if ((!Object.keys(recipient).length && !Object.keys(newRecipient).length)
      || (this.props.campaign && this.applicationIsIncomplete(application)))
      return;

    await this.props.addRecipient(!this.state.checkCampaignRules, newRecipient.applicantId || recipient.applicantId,
      this.props.campaign ? application : (this.state.checkCampaignRules === false ? addToActiveCampaign : false));

    if (this.props.success) {
      this.onClose();
    } else {
      if (this.state.checkCampaignRules && this.props.message && (this.props.message.indexOf("60 days") >= 0 || this.props.message.indexOf("active campaigns") >= 0)) {
        this.toggleModal(this.props.message.indexOf("active campaigns") >= 0 ? 'campaignAddToActiveRuleAlertModal' : 'campaign60DayRuleAlertModal');
      } else {
        this.setState({ error: true });
      }
    }
  }

  onClose = () => {
    this.props.close();
    this.setState(initialState);
  }

  onChange = (name, value) => {
    this.setState({ [name]: value });
  }

  onSelectRecipient = (name, value) => {
    if (value && this.props.campaign) {
      this.setState({
        loadingRecipientDetails: true,
        error: false
      }, async () => {
        const recipientRes = await getRequest(`/recipients/${value.applicantId}`);

        if (recipientRes.success) {
          const recipient = recipientRes.data;

          let recipientHistory = [];
          if (this.props.campaign) {
            const historyRes = await getRequest(`/recipients/${value.applicantId}/applications`);

            if (historyRes.success)
              recipientHistory = historyRes.data;
          }

          this.setState({
            [name]: {
              applicantId: recipient.applicantId,
              name: recipient.displayName,
              isIsraeli: recipient.isIsraeli,
              address: recipient.address,
              references: recipient.references,
              trustedPayee: recipient.trustedPayee
            },
            recipientHistory,
            loadingRecipientDetails: false
          });

        } else {
          this.setState({
            [name]: value,
            recipientHistory: [],
            loadingRecipientDetails: false,
            error: true
          });
        }
      });

    } else {
      this.setState({
        [name]: value,
        recipientHistory: []
      });
    }
  }

  render() {
    const { recipient, newRecipient, recipientHistory, dataErrors, error, loadingRecipientDetails, showModals, submitAttempted, wizzardStep } = this.state;
    const { campaign, campaignList, campaignIndivCategories, defaultIsraelFund, defaultUSFund, funds, loading, message, recipientTypes, references, show } = this.props;

    return (
      <div>
        <Modal modalShowing={show}>
          {!showModals.createRecipientModal && <div className="modal-container">
            <div className="modal add-participant-modal large-modal">
              <div className="modal-header">
                <div>
                  <h4 className="page-header">{campaign ? campaign.name : campaignList.name}</h4>
                  <p className="medium-text">Add Recipient</p>
                </div>
                <i className="icon ion-ios-close-empty" onClick={this.onClose}></i>
              </div>

              <div className="modal-section">
                {wizzardStep === 1
                  ? <div>
                    <div className="modal-row flex-center">
                      {newRecipient.applicantId ? <div><label className="input-label">Recipient</label><span>{newRecipient.name}</span></div>
                        : <div className="search-input-container">
                          <ValidatedInput input={
                            <AutoSuggestInput
                              allowIncomplete={false}
                              suggestions={this.props.recipientSuggestions.data}
                              suggestionKey="applicantId" suggestionValue="name"
                              getSuggestions={this.props.getRecipientSuggestions}
                              clearSuggestions={this.props.clearRecipientSuggestions}
                              loadingSuggestions={this.props.recipientSuggestions.loading}
                              update={this.onSelectRecipient}
                              suggestionAction={suggestion =>
                                <Link className="btn btn-primary input" target={"_blank"} to={`/recipient-accounts/${suggestion.applicantId}`}>View</Link>} />}
                            label="Select Recipient"
                            name="recipient" value={recipient}
                            required={true} showRequiredError={submitAttempted} />
                        </div>}
                      <div>
                        {newRecipient.applicantId ? <span onClick={() => this.setState({ newRecipient: {} })}>
                          <i className="icon ion-ios-close-outline accent-text hover"></i>
                        </span>
                          : loadingRecipientDetails ? <div style={{ marginTop: "-28px" }}><LoadingSpinner height="15" alignRight={true} /></div> :
                            <button className="btn btn-accent2"
                              onClick={() => {
                                this.setState({
                                  recipient: initialState.recipient,
                                  recipientHistory: initialState.recipientHistory
                                }, () => this.toggleModal("createRecipientModal"));
                              }}>
                              <i className="icon ion-ios-plus-empty icon-left"></i>Create</button>}
                      </div>
                    </div>{recipientHistory.length > 0 && <div style={{marginTop: "24px"}}>
                      <p style={{fontWeight: "bold", marginBottom: "16px"}}>Application History</p>
                      <div className="applications-list">
                        {recipientHistory.map(application => <div key={application.applicationId} className="application">
                          <p className="small-text">{application.reason || application.campaign}</p>
                          <p className="small-text">{application.campaignIndividualCategory ? application.campaignIndividualCategory : ''}</p>
                          <p className="small-text">{formatCurrency(application.amount, application.currency === CurrencyTypes.Shekel)}</p>
                          <p className="small-text accent-text">{formatDate(application.date)}</p>
                          <ApplicationStatusTag status={application.status} />
                        </div>
                        )}
                      </div>
                    </div>}
                  </div>
                  : <CampaignRecipientApplication
                    campaign={campaign}
                    recipient={newRecipient.applicantId ? newRecipient : recipient}
                    references={references}
                    recipientTypes={recipientTypes}
                    campaignIndivCategories={campaignIndivCategories}
                    israelFunds={funds.IL}
                    usFunds={funds.US}
                    defaultUSFund={defaultUSFund}
                    defaultIsraelFund={defaultIsraelFund}
                    submitAttempted={submitAttempted}
                    dataErrors={dataErrors}
                    onChange={this.onChange}
                  />}
              </div>

              {loading ? <LoadingSpinner height="20" alignRight={true} /> :
                <div className="modal-btns text-right">
                  <button className="btn btn-accent" onClick={this.onClose}>Cancel</button>
                  {campaign && wizzardStep === 1
                    ? <button className="btn btn-primary" disabled={!Object.keys(this.state.recipient).length && !Object.keys(this.state.newRecipient).length}
                      onClick={() => this.setState({ wizzardStep: 2 })}>Continue</button>
                    : <button className="btn btn-primary" disabled={dataErrors.length}
                      onClick={() => this.onSubmit(false)}>Submit</button>}
                  <FadeOutErrorMessage show={error} message={message} />
                </div>}
            </div>
          </div>}
        </Modal>
        
        <CreateCampaignRecipientModal
          show={showModals.createRecipientModal}
          close={() => this.toggleModal("createRecipientModal")}
          locationId={campaign ? campaign.locationId : !campaignList.organizationName ? campaignList.locationId : null}
          getRecipientSuggestions={this.props.getRecipientSuggestions}
          onContinue={recipient => this.setState({
            newRecipient: {
              applicantId: recipient.id || recipient.applicantId,
              name: recipient.fullName || recipient.displayName,
              isIsraeli: recipient.isIsraeli,
              address: recipient.address,
              references: recipient.references,
              trustedPayee: recipient.trustedPayee
            }
          })}
          recipientType={(campaignList && (campaignList.campaignListType === CampaignListTypes.External || campaignList.organizationName))
            ? RecipientTypes.Individual 
            : this.props.recipientType} /> 

        <WarningModal
          show={showModals.campaign60DayRuleAlertModal}
          close={() => this.toggleModal("campaign60DayRuleAlertModal")}
          message={message}
          continue={() => {
            this.setState({ checkCampaignRules: false }, () => this.onSubmit(false));
          }} />

        <WarningModal
          show={showModals.campaignAddToActiveRuleAlertModal}
          close={() => this.toggleModal("campaignAddToActiveRuleAlertModal")}
          message={message}
          confirmationMessage={"Do you want to add this participant to these campaign(s)?"}
          cancelText={"No"}
          continueText={"Yes"}
          cancel={() => {
            this.setState({ checkCampaignRules: false }, () => this.onSubmit(false));
          }}
          continue={() => {
            this.setState({ checkCampaignRules: false }, () => this.onSubmit(true));
          }} />

      </div >
    )
  }
} 


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignsCommon/AddCampaignRecipientModal.jsx